import React from 'react';
import { useStyletron } from 'baseui';

import { FormBuilder } from 'commons-ui';
import useEdit from '../editConfig/useEdit';
import { ADD_NEW_PG_FORM_LAYOUT_CONFIG, addNewPGFormConfig, validationSchema, defaultAddNewPgData } from '../../utils/formConfig';

const AddNewPgFormContent = () => {
	const [css] = useStyletron();

	const { showLoader, handleAddNewPg, handleModalClose, setShowLoader, paymentGatewayList } = useEdit();
	addNewPGFormConfig.pgName.renderProps.options = paymentGatewayList;
	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={defaultAddNewPgData}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleAddNewPg}
				handleFormCancel={handleModalClose}
				setShowLoader={setShowLoader}
				fieldConfig={addNewPGFormConfig}
				layoutConfig={ADD_NEW_PG_FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Add PG',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default AddNewPgFormContent;
